import * as HttpRequest from "EstruturaAntiga/assets/httpRequest"
import urlBase from "../../assets/urlsBase"
import axios from 'axios'

export default async function postCancelarContrato(data) {
	try{
		let url = `${urlBase.urlBase}/portaldb/ContratosFinanceiros/Cancelar`;
		axios.defaults.headers = await HttpRequest.axiosApiTokenHeader();

		const result = await axios.post(url, data);
		return Promise.resolve(result.data);
  	} catch (error) {
		return Promise.reject(error);
	}
}
